import { useEffect, useState } from 'react';
import { mocApi } from '../api/client';
import { useAuth } from '../context/AuthContext';

// Site filter for the national administrator (ROLE-12): exposes all sites + selection.
export function useSiteFilter() {
  const { user } = useAuth();
  const [sites, setSites] = useState([]);
  const [site, setSite] = useState('all');
  const isNational = (user?.mocRoles || []).some((r) => (r.Role_ID || r.role_id) === 'ROLE-12');
  useEffect(() => {
    if (!isNational) return;
    mocApi.listSites().then((s) => setSites(Array.isArray(s) ? s : [])).catch(() => {});
  }, [isNational]);
  return { sites, isNational, site, setSite };
}
